import { render, staticRenderFns } from "./Cleaning.vue?vue&type=template&id=52e21fc0"
import script from "./Cleaning.vue?vue&type=script&lang=js"
export * from "./Cleaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports